<template>
  <div v-if="!showForm" class="card card-plain">
    <div  class="card-body pt-0">
      <div class="mb-3">
        <label class="text-lg" for="rewardType">Typ výhry</label>
        <select
          class="form-select form-select-lg"
          name="rewardType"
          v-model="selectedRewardType"
        >
          <option :value="null" disabled>Vyber si typ výhry</option>
          <option v-for="(reward, index) in rewardData" :key="index" :value="reward">{{ reward.RewardName }}</option>
        </select>
      </div>
      <div v-if="selectedRewardType">
        <div class="text-center ms-auto mb-3">
          <img
            class="border-radius-lg img-fluid reward-img reward-zoom"
            :src="imgRoot + selectedRewardType.RewardImg"
            :alt="selectedRewardType.RewardName"
            role="button"
            @click.stop="openRewardPhoto"
          >
        </div>
        <div class="mb-3">
          <h5>{{ selectedRewardType.RewardName }}</h5>
          <p class="text-sm">{{ selectedRewardType.RewardText }}</p>
        </div>
        <argon-button
          v-if="selectedRewardType.RewardType === 'ST_P'"
          class="mt-2"
          color="primary"
          size="md"
          @click="showForm = !showForm"
          fullWidth
        >
          Pokračovat k výběru výhry
        </argon-button>
        <argon-button
          v-else
          class="mt-2"
          color="primary"
          size="md"
          :disabled="submitting"
          @click="withDrawReward"
          fullWidth
        >
          Vybrat výhru
        </argon-button>
      </div>
    </div>
  </div>
  <div v-else class="card card-plain">
    <div class="card-body pt-0">
      <h5 class="mb-3">{{ selectedRewardType.RewardName }}</h5>
      <form @submit.prevent="withDrawReward">
        <div class="form-group">
          <label class="text-md" for="rewardDesc">Zadej dodací adresu/poznámku</label>
          <textarea 
            class="form-control" 
            id="rewardDesc" 
            name="rewardDesc" 
            rows="10" 
            placeholder="Dodací adresa/poznámka..."
            v-model="message.RewardDesc"
            @blur="v$.RewardDesc.$touch"
          >
          </textarea>
          <span v-if="v$.RewardDesc.$error" class="text-danger text-sm">
            {{ v$.RewardDesc.$errors[0].$message }}
          </span>
        </div>
        <div class="text-end">
          <argon-button
          class="mt-2"
          color="primary"
          variant="outline"
          size="md"
          @click.prevent="showForm=!showForm"
          >
            Zpět
          </argon-button>
          <argon-button
          class="mt-2 ms-2"
          type="submit"
          color="primary"
          size="md"
          :disabled="submitting"
          >
            Vybrat výhru
          </argon-button>
        </div>
      </form>
    </div>
  </div>
</template>
<script setup>
import { ref, reactive, computed, inject } from 'vue';
import { useStore } from 'vuex';
import dataService from '@/services/dataService';
import { useVuelidate } from '@vuelidate/core';
import { required, helpers } from '@vuelidate/validators';
import ArgonButton from "@/components/ArgonButton.vue";
import { rewardLightboxPayload } from "@/helpers/rewardGallery";

const props = defineProps({
  gameId: Number,
  rewardData: Object
})
const emit = defineEmits(['withdraw-reward-success']);

const store = useStore();
const swal = inject('$swal');

const showForm = ref(false);
const submitting = ref(false);
const selectedRewardType = ref(null);
const imgRoot = computed(() => process.env.VUE_APP_IMG_ROOT);

const openRewardPhoto = () => {
  const reward = selectedRewardType.value;
  const payload = rewardLightboxPayload(
    imgRoot.value,
    reward?.RewardName || 'Výhra',
    reward?.RewardImg,
    reward?.RewardImgs
  );
  if (!payload.src) return;
  store.dispatch('openLightbox', payload);
};
const initialStateRewardDesc = { RewardDesc: '', };
const message = reactive({ ...initialStateRewardDesc });
const sessionUserID = computed(() => store.getters.getUser.UserID);
const sessionHash = computed(() => store.getters.isLoggedIn);

const rules = computed(() => {
  return {
    RewardDesc: { 
      required: helpers.withMessage('Zadej dodací adresu/poznámku', required),
      //minLength: helpers.withMessage('Zadej dodací adresu/poznámku', minLength(20)),
    },
  }
})
// initialize vuelidate
const v$ = useVuelidate(rules, message);

const withDrawReward = async () => {
  if (submitting.value) return;
  submitting.value = true;

  if (selectedRewardType.value && selectedRewardType.value.RewardType === 'ST_P') {
    const isFormCorrect = await v$.value.$validate();
    if (!isFormCorrect) {
      // eslint-disable-next-line require-atomic-updates
      submitting.value = false;
      return;
    }
  }

  const response = await dataService.ChooseReward(sessionUserID.value, sessionHash.value, props.gameId, selectedRewardType.value.RewardType, message.RewardDesc);
  
  if (response.Result) emit('withdraw-reward-success');
  store.dispatch('closeModal');

  // Show SweetAlert2
  swal.fire({
    position: 'center',
    icon: response.Result ? 'success' : 'error',
    html: response.Result ? 
      `<h5>${response.InfoMessage[0]}</h5>` + `<p>${response.InfoMessage[1]}</p>` : 
      `${response.ErrorMessage.map(message => `<h5>${message}</h5>`).join('')}`,
    showConfirmButton: false,
    timer: 3000
  });
};

</script>

<style scoped>
.reward-zoom {
  cursor: zoom-in;
}
</style>
